import MedicaidHistoryModal from './MedicaidHistoryModal';

export default MedicaidHistoryModal;
